import React from "react";
import { HomePreviewSubPodcastListLoaderTemplate } from "themes/application/home/components";

function HomePreviewSubPodcastListLoader(props) {
    return <HomePreviewSubPodcastListLoaderTemplate {...props} />;
}

export default HomePreviewSubPodcastListLoader;
